module.exports = __webpack_public_path__ + "img/pluto42.78b60dfe.jpg";